export type ProfileAddress={country:string;address1:string;address2:string;postalCode:string;city:string};

const countries=new Set(['CH','DE','FR','IT','PT']);
export function parseProfileAddress(value:string):ProfileAddress{
 const lines=value.split('\n').map(line=>line.trim()).filter(Boolean);
 const country=countries.has(lines[0]?.toUpperCase())?lines.shift()!.toUpperCase():'CH';
 const address1=lines.shift()||'';
 const place=lines.length?lines.pop()! : '';
 const address2=lines.join(', ');
 const match=place.match(/^([A-Z]{0,2}-?\d{4,6})\s+(.+)$/i);
 return {country,address1,address2,postalCode:match?.[1]||'',city:match?.[2]||place};
}
export function formatProfileAddress(address:ProfileAddress):string{
 return [address.country.trim().toUpperCase(),address.address1.trim(),address.address2.trim(),[address.postalCode.trim(),address.city.trim()].filter(Boolean).join(' ')].filter(Boolean).join('\n');
}
